<div class="modal-header">
  <h4 class="modal-title h5" translate>Send command / configuration to gateway</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="gatewayCommunicationForm">

  <div class="modal-body">
    <div class="form-row">
      <!-- REQUEST NAME -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="requestName">
            <span translate>Request name</span>
            <scitis-required-field-indicator></scitis-required-field-indicator>
          </label>
          <ng-select (change)="onRequestNameChange($event)"
            [clearable]="false"
            [items]="requestNames"
            [ngClass]="{ 'is-invalid': f.requestName.errors }"
            [placeholder]="'Select request name' | translate" [title]="'Select request name'|translate"
            formControlName="requestName"
            id="requestName">
          </ng-select>
        </div>
      </div>

      <!-- REQUEST TYPE -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="requestType">
            <span translate>Action type</span>
            <scitis-required-field-indicator></scitis-required-field-indicator>
          </label>
          <ng-select (change)="onRequestTypeChange($event)"
            [clearable]="false"
            [items]="requestTypes"
            [ngClass]="{ 'is-invalid': f.requestType.errors }"
            [placeholder]="'Select request type' | translate" [title]="'Select request type'|translate"
            formControlName="requestType"
            id="requestType">
          </ng-select>
        </div>
      </div>
    </div>
    <div class="form-row">
      <!-- OFFSET HOURS -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="offsetHours" translate>Offset hours</label>
          <input [ngClass]="{ 'is-invalid': f.offsetHours.errors }" class="form-control" formControlName="offsetHours"
            id="offsetHours" min="0"
            name="offsetHours"
            type="number">
          </div>
        </div>

        <!-- SERVICE INTERVAL -->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="offsetHours" translate>Service interval</label>

            <input [ngClass]="{ 'is-invalid':  f.serviceInterval.errors }" class="form-control"
              formControlName="serviceInterval"
              id="serviceInterval"
              min="0" name="serviceInterval"
              type="number">
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col">
            <label class="form-label" for="servicePerformed" translate>Service performed</label>

          </div>
          <div class="col-auto">
            <div class="custom-control custom-switch d-inline-flex">
              <input (change)="isServicePerformedChanged()"
                class="custom-control-input"
                id="servicePerformed"
                type="checkbox">
                <label class="custom-control-label" for="servicePerformed" translate>Service performed</label>
              </div>
            </div>
          </div>
          @if (isCommandRequest) {
            <div class="alert alert-info text-center">
              <span translate>To send commands to an Hono IoT Device, the device must be connected and subscribed to MQTT command topic.</span>
            </div>
          }

        </div>
        <!--FOOTER-->
        <scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
          (okButtonPressed)="onGatewayCommunication($event)"
          [disableOkButton]="gatewayCommunicationForm.invalid || requestSent"
          [okButtonText]="'Send'"
          [showRequiredFieldsIndicator]="true">
        </scitis-modal-footer>
      </form>